import { Environment } from './types'

export const developmentEnvironment: Environment = {
	// API
	API_URL: 'https://api.brandtrack.dev',
	API_TIMEOUT: 60000,
	FIXED_API_URL: '',

	// App
	APP_NAME: 'MyBrandTrack (Dev)',
	APP_VERSION: '3.0.0',
	COMPANY_NAME: 'Brandtrack',

	// Features
	ENABLE_POSTHOG: 'partial',
	ENABLE_AMPLITUDE: 'partial',

	// Other
	NODE_ENV: 'development',

	// Build type
	BUILD_TYPE: 'brandtrack',
}
